// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__IFelj","content":"styles_content__74tbC","checkbox":"styles_checkbox__vCQ1G","checkboxLabel":"styles_checkboxLabel__1tlRY"};